import React from "react";
import SimpleTable from "my-simple-react-table";
import { formatAmount, formatDate } from "../../../../../../../../../util/Helpers";

const LockedBalances = ({balances, currency}) => {

    if (balances.length === 0){
        return null;
    }

    return <div className="row">
                <div className="col-12">
                    {/* <!--begin::List Widget 14--> */}
                    <div className="card card-custom gutter-b">
                        {/* <!--begin::Header--> */}
                        <div className="card-header border-0">
                            <h3 className="card-title font-weight-bolder text-dark">Locked Balances</h3>
                        </div>
                        {/* <!--end::Header--> */}
                        {/* <!--begin::Body--> */}
                        <div className="card-body pt-0">
                            {/* <!--begin::Item--> */}
                            <SimpleTable
                                data={balances}
                                columns={[
                                            {title:"REASON", format: row => <span title={row.id}>{row.reason}</span>},
                                            {title: "AMOUNT", format: row => formatAmount(currency, row.amount)},
                                            {title: "DATE", format: row => formatDate(row.date)}
                                        ]} 
                                searchBox={false}
                                rowPerPage={4}
                            />
                            {/* <!--end::Item--> */}
                        </div>
                        {/* <!--end::Body--> */}
                    </div>
                    {/* <!--end::List Widget 14--> */}
                </div>
            </div>
}

export default LockedBalances;